export const environment = {
  production: false,
  apiURL: 'https://consmmefapi.labyeducation.com',
};
